import { tailwindVariants } from '@air/utils-tailwind';

/** Chrome for a `WorkspaceAgentMentionFilterChip`, and for the caret segment the brand kit chip adds beside one. */
export const workspaceAgentMentionFilterChip = tailwindVariants({
  base: 'inline-flex h-6 max-w-36 shrink-0 cursor-pointer items-center rounded-full border px-2 text-12 leading-none transition-colors motion-reduce:transition-none',
  defaultVariants: {
    isActive: false,
    isCaret: false,
  },
  variants: {
    isActive: {
      // `bg-gray-2`, not the prototype's `gray-1`: the popup's own ground is gray-1, so an unfilled
      // chip has no boundary of its own — the same call the history chip made.
      false: 'border-gray-5 bg-gray-2 font-medium text-gray-11 hover:bg-gray-3 hover:text-gray-12',
      // Border and weight as well as fill: altitude-3 against an unfilled chip is a faint tint on its
      // own, and active must not be carried by hue alone. `font-semibold`, not the prototype's medium, per 1.4.1.
      true: 'border-altitude-7 bg-altitude-3 font-semibold text-altitude-12',
    },
    /**
     * The caret half of the brand kit chip: the same chrome, joined to the label's right edge and
     * padded for a glyph rather than for copy. It is drawn `isActive: false` even while the tab is
     * active — the fill says which tab is on, and the caret is not the tab. A variant rather than a
     * literal of its own, so the two halves of one control cannot drift apart.
     */
    isCaret: {
      true: 'max-w-none rounded-l-none pr-1 pl-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-altitude-9',
    },
  },
});
